import { Component, ViewEncapsulation, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'related-articles, app-related-articles',
  templateUrl: './related-articles.component.html',
  styleUrls: ['./related-articles.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RelatedArticlesCardComponent extends CardComponent implements OnChanges {
  relatedArticles1 = [];
  relatedArticles2 = [];
  relatedArticles3 = [];
  @Input() relatedArticles = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.relatedArticles && this.relatedArticles.length === 1) {
      this.relatedArticles1 = this.relatedArticles[0];
    }

    if (this.relatedArticles && this.relatedArticles.length === 2) {
      this.relatedArticles1 = this.relatedArticles[0];
      this.relatedArticles2 = this.relatedArticles[1];
    }

    if (this.relatedArticles && this.relatedArticles.length === 3) {
      this.relatedArticles1 = this.relatedArticles[0];
      this.relatedArticles2 = this.relatedArticles[1];
      this.relatedArticles3 = this.relatedArticles[2];
    }
  }
}